import React from 'react'
import { Typography } from '@mui/material'

export const Footer: React.FC = () => (
  <Typography variant="body2">Fintastic © 2021</Typography>
)
